import { z } from 'zod';
import { InputRegexMap, OnboardingFormFields } from '@Types/index.ts';
import { t } from 'i18next';
import { Line1Schema } from '@Components/inputs/Line1';
import { AddressStateSchema } from '@Components/inputs/AddressStateDropDown';
import { zipSchema } from '@Components/inputs/ZipAddress/';

const MAX_CITY_CHARS = 21;

export const HomeAddressFormScheme = z.object({
  ...Line1Schema.shape,
  [OnboardingFormFields.APARTMENT]: z.string().optional(),
  [OnboardingFormFields.CITY]: z
    .string()
    .min(1, t('enErrors:address.city.required'))
    .min(2, t('enErrors:address.city.min'))
    .max(
      MAX_CITY_CHARS,
      t('enErrors:address.city.max', {
        max: MAX_CITY_CHARS,
      })
    )
    .regex(InputRegexMap.cityUS, t('enErrors:address.city.invalid')),
  ...zipSchema.shape,
  ...AddressStateSchema.shape,
});
